import React from "react";
import { cn } from "@/lib/utils";

const COLORS = {
  scheduled: { bg: "bg-sky-100", text: "text-sky-800", dot: "bg-sky-500" },
  arrived: { bg: "bg-emerald-100", text: "text-emerald-800", dot: "bg-emerald-500" },
  treatment: { bg: "bg-indigo-100", text: "text-indigo-800", dot: "bg-indigo-500" },
  finished: { bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500" },
  reschedule: { bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500" },
  cancel: { bg: "bg-rose-100", text: "text-rose-800", dot: "bg-rose-500" },
};

const LABELS = {
  scheduled: "Scheduled",
  arrived: "Arrived",
  treatment: "Treatment",
  finished: "Finished",
  reschedule: "Reschedule",
  cancel: "Cancel",
};

export default function StatusBadge({ status, className }) {
  const c = COLORS[status] || COLORS.scheduled;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
        c.bg,
        c.text,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", c.dot)} />
      {LABELS[status] || status}
    </span>
  );
}
